import React from 'react';

function GitPage() {
    return <div />;
} // 61c130a811696b738cfeeabac866455df5f72625

export default GitPage;
